import { memo, useCallback } from 'react';

import { BooleanOption, Flex, Label, SelectOption, Text } from '@/components/core';
import { FieldConfig } from '@/components/ui';
import { useModelConfigStore } from '@/store';

import { LLM_MODELS, UserSettings } from './utils';

const ISetup = () => {
  const metadata = useModelConfigStore((state) => state.metadata);
  const updateMetadata = useModelConfigStore((state) => state.updateMetadata);
  const userSettings = metadata?.['user:settings'] as UserSettings | undefined;

  const updateSetting = useCallback(
    (key: string, value: string | number | boolean) => {
      updateMetadata({ 'user:settings': { ...userSettings, [key]: value } });
    },
    [updateMetadata, userSettings]
  );

  return (
    <Flex col className="p-md gap-md">
      <SelectOption
        label="Base model"
        tooltip="The base model"
        items={LLM_MODELS}
        defaultSelectedKey={userSettings?.base_model ?? LLM_MODELS[1].id}
        className="gap-xs items-start"
        col
      />

      <BooleanOption
        label="Continuous AI training"
        description="Use reviewed data to improve accuracy on similar documents."
        isSelected={userSettings?.use_few_shot_learning != null ? userSettings?.use_few_shot_learning : true}
        onChange={(val) => updateSetting('use_few_shot_learning', val)}
        col
      />

      <Flex col className="gap-sm">
        <Flex col>
          <Label>Instructions</Label>
          <Text>Define the data you want your model to extract.</Text>
        </Flex>
        <Flex col variant="plain" className="rounded-md border-1 border-gray-100 bg-gray-50">
          <FieldConfig />
        </Flex>
      </Flex>
    </Flex>
  );
};

export const Setup = memo(ISetup);
